export const urlQueryParamsMap = Object.freeze({
  price: 'wsp',
  'sort-by': 'sortBy',
  'on-offer': 'onOffer',
  'search-query': 'searchQuery',
});
